export default __webpack_public_path__ + "static/media/white-star.bf5d9054.svg";